
const state = () => ({ zIndex: null })

const getters = {
  zIndex: state => {
    return state.zIndex
  },
}

const mutations = {
  setZIndex (state, data) {
    console.log('setZIndex', data)
    state.zIndex = data
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
}
